/* eslint-disable */
<template>
	<section>
		<div class="smaller-heading">Vielen Dank</div>
		<div class="text">
			<p>Ihr Zimmercode wurde gedruckt und Ihnen an diese Email gesendet:</p><br>
			<p>{{booking.email}}</p>

			<div class="room_heading">Zimmercode</div>
			<p>Der Zimmercode ist für <strong>Ihr Zimmer</strong> und die <strong>Eingangstüre gültig</strong></p>

			<div class="room_heading">Buchungen</div>
			<p>Sie können folgene Zimmer beziehen:</p>
			<div>
				<div v-for="room of booking.rooms">{{room.room.room_name}} - {{room.room.roomSetting.name}}</div>
			</div>
			<!-- <p style="font-weight:bold;">Zimmer {{booking.room.room_number}}</p> -->
		</div>
		<div class="button_wrapper">
			<router-link :to="{ name: 'welcome'}">
				<button class="button">Zur Übersicht</button>
			</router-link>
		</div>
	</section>
</template>
<script>
export default {
	name: 'IndexList',

	components: {},
	computed: {
		booking () {
			return this.$store.state.booking
		}
	},

	data () {
		return {}
	},

	created () {
		// this.fetchData();
	},

	methods: {
		fetchData () {}
	}
}
</script>
<style >
	.smaller-heading {
		margin-top: 1em;
	}
	.room_heading {
		font-weight: bold;
		font-size: 1.25em;
		margin-top: 1.5em;
	}
	.button_wrapper {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Thankyou.vue